import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authApi, getAccessToken, clearTokens } from '@/lib/api';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = getAccessToken();

    if (!token) {
      setIsChecking(false);
      setIsAuthenticated(false);
      return;
    }

    // Verify token is still valid
    authApi.getMe().then((response) => {
      if (response.error) {
        clearTokens();
        setIsAuthenticated(false);
      } else {
        setIsAuthenticated(true);
      }
      setIsChecking(false);
    });
  }, []);

  if (isChecking) {
    return null;
  }

  if (!isAuthenticated) {
    // Redirect to login, preserving the intended destination
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
